import { render, staticRenderFns } from "./add_wy.vue?vue&type=template&id=8e1a44b4&scoped=true&"
import script from "./add_wy.vue?vue&type=script&lang=js&"
export * from "./add_wy.vue?vue&type=script&lang=js&"
import style0 from "./add_wy.vue?vue&type=style&index=0&id=8e1a44b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e1a44b4",
  null
  
)

export default component.exports